import { Injectable } from '@angular/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class DeficiencyTicketWatchersDbTableDefinition extends DbTableDefinition {
  tableName = 'deficiencyTicketWatchers';
  tableStructure = `(id BIGINT(20) PRIMARY KEY null,
     watcherobjref VARCHAR(45),
     watcherid BIGINT(20),
     deficiencyticketid BIGINT(20),
     databag LONGTEXT
    );`;

  constructor() {
    super();
    this.updateStatements.set(44, [
      `CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`,
    ]);
  }
}
